module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать адрес\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'address-details',
        params: {
          address_id: _vm.address.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям адреса")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.address.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteAddress.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить адрес")]) : _vm._e()]), _vm._v(" "), _c('address-edit-form', {
    attrs: {
      "address": _vm.address
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0c3febe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/address/AddressEdit.vue
// module id = 693
// module chunks = 0